import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import api from '../services/api'

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';
import $ from 'jquery'
import { asyncForEach } from '../utils/functions';
import Papa from 'papaparse';

const swal2 = withReactContent(Swal)

function Importacao() {

  const [data, setData] = useState({})
  const [texto, setTexto] = useState('')

  function consistData(data) {

    if ((!data.arquivo) && (!data.arquivo_contratos) && (!data.arquivo_empresas) && (!data.arquivo_historicos) && (!data.arquivo_dependentes)
      && (!data.arquivo_mensalidades) && (!data.arquivo_cto_emp) && (!data.arquivo_mensalidades_empresas) && (!data.arquivo_cobranca)
      && (!data.arquivo_caixa) && (!data.arquivo_lancamentos) && (!data.arquivo_renovacoes) && (!data.arquivo_hist_empresas) && (!data.arquivo_nota_servico)
      && (!data.arquivo_nota_fiscal)
    )
      return 'Selecione um arquivo para importação'
    else
      return ''
  }

  const selectFile = (e) => {
    e.preventDefault();
    $('#html_btn').click();
  }

  const selectFileContratos = (e) => {
    e.preventDefault();
    $('#html_contratos').click();
  }

  const selectFileEmpresas = (e) => {
    e.preventDefault();
    $('#html_empresas').click();
  }

  const selectFileHistoricos = (e) => {
    e.preventDefault();
    $('#html_historicos').click();
  }

  const selectFileDependentes = (e) => {
    e.preventDefault();
    $('#html_dependentes').click();
  }

  const selectFileMensalidades = (e) => {
    e.preventDefault();
    $('#html_mensalidades').click();
  }

  const selectFileMensalidadesEmpresas = (e) => {
    e.preventDefault();
    $('#html_mensalidades_empresas').click();
  }

  const selectFileCto_Emp = (e) => {
    e.preventDefault();
    $('#html_cto_emp').click();
  }

  const selectFileCobranca = (e) => {
    e.preventDefault();
    $('#html_cobranca').click();
  }

  const selectFileCaixa = (e) => {
    e.preventDefault();
    $('#html_caixa').click();
  }

  const selectFileLancamentos = (e) => {
    e.preventDefault();
    $('#html_lancamentos').click();
  }

  const selectFileRenovacoes = (e) => {
    e.preventDefault();
    $('#html_renovacoes').click();
  }

  const selectFileHistEmpresas = (e) => {
    e.preventDefault();
    $('#html_hist_empresas').click();
  }

  const selectFileNotaServico = (e) => {
    e.preventDefault();
    $('#html_nota_servico').click();
  }

  const selectFileNotaFiscal = (e) => {
    e.preventDefault();
    $('#html_nota_fiscal').click();
  }

  const handleSelectedFile = (e) => {
    let file = e.target.files[0];
    let auxValues = { ...data }
    if (file) {
      auxValues.arq = file
      auxValues.arquivo = file.name
    } else {
      auxValues.arq = null
      auxValues.arquivo = 'Nenhum arquivo selecionado'
    }
    setData(auxValues)
  }

  const handleFileContratos = (e) => {
    let file = e.target.files[0];
    let auxValues = { ...data }
    if (file) {
      auxValues.arq_contratos = file
      auxValues.arquivo_contratos = file.name
    } else {
      auxValues.arq_contratos = null
      auxValues.arquivo_contratos = 'Nenhum arquivo selecionado'
    }

    setData(auxValues)
  }

  const handleFileNotaServico = (e) => {
    let file = e.target.files[0];
    let auxValues = { ...data }
    if (file) {
      auxValues.arq_nota_servico = file
      auxValues.arquivo_nota_servico = file.name
    } else {
      auxValues.arq_nota_servico = null
      auxValues.arquivo_nota_servico = 'Nenhum arquivo selecionado'
    }

    setData(auxValues)
  }

  const handleFileNotaFiscal = (e) => {
    let file = e.target.files[0];
    let auxValues = { ...data }
    if (file) {
      auxValues.arq_nota_fiscal = file
      auxValues.arquivo_nota_fiscal = file.name
    } else {
      auxValues.arq_nota_fiscal = null
      auxValues.arquivo_nota_fiscal = 'Nenhum arquivo selecionado'
    }

    setData(auxValues)
  }

  const handleFileEmpresas = (e) => {
    let file = e.target.files[0];
    let auxValues = { ...data }
    if (file) {
      auxValues.arq_empresas = file
      auxValues.arquivo_empresas = file.name
    } else {
      auxValues.arq_empresas = null
      auxValues.arquivo_empresas = 'Nenhum arquivo selecionado'
    }

    setData(auxValues)
  }

  const handleFileHistoricos = (e) => {
    let file = e.target.files[0];
    let auxValues = { ...data }
    if (file) {
      auxValues.arq_historicos = file
      auxValues.arquivo_historicos = file.name
    } else {
      auxValues.arq_historicos = null
      auxValues.arquivo_historicos = 'Nenhum arquivo selecionado'
    }

    setData(auxValues)
  }

  const handleFileDependentes = (e) => {
    let file = e.target.files[0];
    let auxValues = { ...data }
    if (file) {
      auxValues.arq_dependentes = file
      auxValues.arquivo_dependentes = file.name
    } else {
      auxValues.arq_dependentes = null
      auxValues.arquivo_dependentes = 'Nenhum arquivo selecionado'
    }

    setData(auxValues)
  }

  const handleFileMensalidades = (e) => {
    let file = e.target.files[0];
    let auxValues = { ...data }
    if (file) {
      auxValues.arq_mensalidades = file
      auxValues.arquivo_mensalidades = file.name
    } else {
      auxValues.arq_mensalidades = null
      auxValues.arquivo_mensalidades = 'Nenhum arquivo selecionado'
    }

    setData(auxValues)
  }

  const handleFileMensalidadesEmpresas = (e) => {
    let file = e.target.files[0];
    let auxValues = { ...data }
    if (file) {
      auxValues.arq_mensalidades_empresas = file
      auxValues.arquivo_mensalidades_empresas = file.name
    } else {
      auxValues.arq_mensalidades_empresas = null
      auxValues.arquivo_mensalidades_empresas = 'Nenhum arquivo selecionado'
    }

    setData(auxValues)
  }

  const handleFileCto_Emp = (e) => {
    let file = e.target.files[0];
    let auxValues = { ...data }
    if (file) {
      auxValues.arq_cto_emp = file
      auxValues.arquivo_cto_emp = file.name
    } else {
      auxValues.arq_cto_emp = null
      auxValues.arquivo_cto_emp = 'Nenhum arquivo selecionado'
    }

    setData(auxValues)
  }

  const handleFileCobranca = (e) => {
    let file = e.target.files[0];
    let auxValues = { ...data }
    if (file) {
      auxValues.arq_cobranca = file
      auxValues.arquivo_cobranca = file.name
    } else {
      auxValues.arq_cobranca = null
      auxValues.arquivo_cobranca = 'Nenhum arquivo selecionado'
    }

    setData(auxValues)
  }

  const handleFileCaixa = (e) => {
    let file = e.target.files[0];
    let auxValues = { ...data }
    if (file) {
      auxValues.arq_caixa = file
      auxValues.arquivo_caixa = file.name
    } else {
      auxValues.arq_caixa = null
      auxValues.arquivo_caixa = 'Nenhum arquivo selecionado'
    }

    setData(auxValues)
  }

  const handleFileLancamentos = (e) => {
    let file = e.target.files[0];
    let auxValues = { ...data }
    if (file) {
      auxValues.arq_lancamentos = file
      auxValues.arquivo_lancamentos = file.name
    } else {
      auxValues.arq_lancamentos = null
      auxValues.arquivo_lancamentos = 'Nenhum arquivo selecionado'
    }

    setData(auxValues)
  }

  const handleFileRenovacoes = (e) => {
    let file = e.target.files[0];
    let auxValues = { ...data }
    if (file) {
      auxValues.arq_renovacoes = file
      auxValues.arquivo_renovacoes = file.name
    } else {
      auxValues.arq_renovacoes = null
      auxValues.arquivo_renovacoes = 'Nenhum arquivo selecionado'
    }

    setData(auxValues)
  }


  const handleFileHistEmpresas = (e) => {
    let file = e.target.files[0];
    let auxValues = { ...data }
    if (file) {
      auxValues.arq_hist_empresas = file
      auxValues.arquivo_hist_empresas = file.name
    } else {
      auxValues.arq_hist_empresas = null
      auxValues.arquivo_hist_empresas = 'Nenhum arquivo selecionado'
    }

    setData(auxValues)
  }

  function handleSubmit(e) {
    e.preventDefault();
    swal2.fire({
      title: 'ATENÇÃO',
      text: "Confirma importação do arquivo?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then(async (result) => {
      if (result.value) {
        const auxValues = { ...data };
        let linha = 0
        let errors = consistData(auxValues)
        if (!errors) {
          const { value: formValues } = await swal2.fire({
            // title: 'Importar a partir da linha',
            html:
              <div style={{
                display: 'flex', flex: 1, marginTop: '20px', flexDirection: 'column',
                alignItems: 'flex-start'
              }}>
                <label>Importar a partir da linha:</label>
                <FrTextInput
                  name="linha"
                  id="linha"
                  color="#083c7c"
                  // label="Importar a partir da linha:"
                  variant="outlined"
                  size="small"
                  style={{ width: 100 }}
                  defaultValue="1"
                />
              </div>,
            focusConfirm: false,
            preConfirm: () => {
              return {
                linha: document.getElementById('linha').value,
              }
            },
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'OK',
            confirmButtonColor: `#083c7c`,
            allowOutsideClick: false
          })

          if (formValues) {
            linha = formValues['linha']
            if (!linha)
              linha = 1
            let url = ''
            let arquivo = ''
            if (auxValues.arq) {
              url = '/clientes/importaLinha'
              arquivo = auxValues.arq
            } else
              if (auxValues.arq_contratos) {
                url = '/contratos/importaLinha'
                arquivo = auxValues.arq_contratos
              } else
                if (auxValues.arq_empresas) {
                  url = '/empresas/importaLinha'
                  arquivo = auxValues.arq_empresas
                } else
                  if (auxValues.arq_historicos) {
                    url = '/historicos/importaLinha'
                    arquivo = auxValues.arq_historicos
                  }
                  else
                    if (auxValues.arq_dependentes) {
                      url = '/dependentes/importaLinha'
                      arquivo = auxValues.arq_dependentes
                    }
                    else
                      if (auxValues.arq_mensalidades) {
                        url = '/contas_receber/importaLinha'
                        arquivo = auxValues.arq_mensalidades
                      }
                      else
                        if (auxValues.arq_cto_emp) {
                          url = '/contratos/importaCtoEmp'
                          arquivo = auxValues.arq_cto_emp
                        }
                        else
                          if (auxValues.arq_mensalidades_empresas) {
                            url = '/contas_receber/importaLinhaEmpresas'
                            arquivo = auxValues.arq_mensalidades_empresas
                          }
                          else
                            if (auxValues.arq_cobranca) {
                              url = '/cobranca/importaLinha'
                              arquivo = auxValues.arq_cobranca
                            } else
                              if (auxValues.arq_caixa) {
                                url = '/controle_caixa/importaLinha'
                                arquivo = auxValues.arq_caixa
                              }
                              else
                                if (auxValues.arq_lancamentos) {
                                  url = '/lancamentos/importaLinha'
                                  arquivo = auxValues.arq_lancamentos
                                }
                                else
                                  if (auxValues.arq_renovacoes) {
                                    url = '/renovacoes/importaLinha'
                                    arquivo = auxValues.arq_renovacoes
                                  }
                                  else
                                    if (auxValues.arq_hist_empresas) {
                                      url = '/historicos_empresas/importaLinha'
                                      arquivo = auxValues.arq_hist_empresas
                                    }
                                    else
                                      if (auxValues.arq_nota_servico) {
                                        url = '/nota_servico/importaLinha'
                                        arquivo = auxValues.arq_nota_servico
                                      }
                                      else
                                        if (auxValues.arq_nota_fiscal) {
                                          url = '/notas_fiscais/importaLinha'
                                          arquivo = auxValues.arq_nota_fiscal
                                        }
            Papa.parse(arquivo, {
              // header: true,
              encoding: "UTF-8",
              complete: function (results) {
                var cabecalho = results.data[0].join(';')+'\n'
                let linhasComErro = []
                console.log(results.data)
                asyncForEach(results.data, async (item, index) => {
                  auxValues.linha = item
                  // console.log(item)
                  if ((index > 0) && (index >= linha))
                    // alert(index)
                    await api.post(url, auxValues)
                      .then(async (r) => {
                        setTexto('Importando arquivo (linhas ' + (index + 1) + ' de ' + results.data.length + ')')
                        if (r.data.status == 'erro') {
                          linhasComErro.push('"' + item.join('";"') + '";"'+r.data.message + '"')
                        } 
                        if (index + 1 === results.data.length) {
                          if (linhasComErro.length > 0) {
                            swal2.fire('Erro', 'houveram erros', 'warning')
                            console.log(linhasComErro)
                    
                            const csvContent = cabecalho + linhasComErro.join('\n');
                            
                            const blob = new Blob([csvContent], { type: 'text/csv' });
                            const url = URL.createObjectURL(blob);
                            
                            const link = document.createElement('a');
                            link.href = url;
                            link.download = 'linhas_com_erro.csv';
                            link.click();
                            
                            URL.revokeObjectURL(url);
                          } else {
                            swal2.fire('Arquivo importado', 'Arquivo importado com sucesso!', 'success');
                          }
                          
                          setTexto('')
                        }
                      })
                    
                  

                });
              }
            })
          }
        } else {
          swal2.fire({
            title: 'Erro!',
            text: errors,
            icon: 'warning',
          })
        }
      }

    })
  }


  function handleCancel(e) {
    e.preventDefault();
    swal2.fire({
      title: 'ATENÇÃO',
      text: "Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    auxValues[e.target.name] = e.target.value;
    setData(auxValues);
  };


  return (
    <div className="defaultReg">
      <NavBar />
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>Importação</h3>
          <UserOptions />
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>

          <input
            type="file"
            name="arquivo"
            id="html_btn"
            accept=".csv"
            onChange={handleSelectedFile}
          />
          <FrTextInput
            value={data.arquivo || ''}
            onChange={handleChange}
            name="arquivo"
            id="arquivo"
            color="#528b46"
            label="Arquivo Clientes"
            variant="outlined"
            size="small"
            disabled
            required
            style={{ width: 300 }}
          />
          <button type="file" className="selectFileButton" onClick={selectFile}>
            Escolher Arquivo
          </button>

          <br />


          <input
            type="file"
            name="arquivo_contratos"
            id="html_contratos"
            accept=".csv"
            onChange={handleFileContratos}
          />
          <FrTextInput
            value={data.arquivo_contratos || ''}
            onChange={handleChange}
            name="arquivo_contratos"
            id="arquivo_contratos"
            color="#528b46"
            label="Arquivo Contratos"
            variant="outlined"
            size="small"
            disabled
            required
            style={{ width: 300 }}
          />
          <button type="file" className="selectFileButton" onClick={selectFileContratos}>
            Escolher Arquivo
          </button>
          <br />
          <input
            type="file"
            name="arquivo_empresas"
            id="html_empresas"
            accept=".csv"
            onChange={handleFileEmpresas}
            style={{ display: 'none' }}
          />
          <FrTextInput
            value={data.arquivo_empresas || ''}
            onChange={handleChange}
            name="arquivo_empresas"
            id="arquivo_empresas"
            color="#528b46"
            label="Arquivo Empresas"
            variant="outlined"
            size="small"
            disabled
            required
            style={{ width: 300 }}
          />
          <button type="file" className="selectFileButton" onClick={selectFileEmpresas}>
            Escolher Arquivo
          </button>

          <br />
          <input
            type="file"
            name="arquivo_historicos"
            id="html_historicos"
            accept=".csv"
            onChange={handleFileHistoricos}
            style={{ display: 'none' }}
          />

          <FrTextInput
            value={data.arquivo_historicos || ''}
            onChange={handleChange}
            name="arquivo_historicos"
            id="arquivo_historicos"
            color="#528b46"
            label="Arquivo Históricos"
            variant="outlined"
            size="small"
            disabled
            required
            style={{ width: 300 }}
          />
          <button type="file" className="selectFileButton" onClick={selectFileHistoricos}>
            Escolher Arquivo
          </button>
          <br />

          <input
            type="file"
            name="arquivo_dependentes"
            id="html_dependentes"
            accept=".csv"
            onChange={handleFileDependentes}
            style={{ display: 'none' }}
          />

          <FrTextInput
            value={data.arquivo_dependentes || ''}
            onChange={handleChange}
            name="arquivo_dependentes"
            id="arquivo_dependentes"
            color="#528b46"
            label="Arquivo Dependentes"
            variant="outlined"
            size="small"
            disabled
            required
            style={{ width: 300 }}
          />
          <button type="file" className="selectFileButton" onClick={selectFileDependentes}>
            Escolher Arquivo
          </button>
          <br />
          <input
            type="file"
            name="arquivo_mensalidades"
            id="html_mensalidades"
            accept=".csv"
            onChange={handleFileMensalidades}
            style={{ display: 'none' }}
          />

          <FrTextInput
            value={data.arquivo_mensalidades || ''}
            onChange={handleChange}
            name="arquivo_mensalidades"
            id="arquivo_mensalidades"
            color="#528b46"
            label="Arquivo Mensalidades"
            variant="outlined"
            size="small"
            disabled
            required
            style={{ width: 300 }}
          />
          <button type="file" className="selectFileButton" onClick={selectFileMensalidades}>
            Escolher Arquivo
          </button>

          <br />

          <input
            type="file"
            name="arquivo_cto_emp"
            id="html_cto_emp"
            accept=".csv"
            onChange={handleFileCto_Emp}
            style={{ display: 'none' }}
          />

          <FrTextInput
            value={data.arquivo_cto_emp || ''}
            onChange={handleChange}
            name="arquivo_cto_emp"
            id="arquivo_cto_emp"
            label="Arquivo Contratos Empresas"
            variant="outlined"
            size="small"
            disabled
            style={{ width: 300 }}
          />
          <button type="file" className="selectFileButton" onClick={selectFileCto_Emp}>
            Escolher Arquivo
          </button>

          <br />
          <input
            type="file"
            name="arquivo_mensalidades_empresas"
            id="html_mensalidades_empresas"
            accept=".csv"
            onChange={handleFileMensalidadesEmpresas}
            style={{ display: 'none' }}
          />

          <FrTextInput
            value={data.arquivo_mensalidades_empresas || ''}
            onChange={handleChange}
            name="arquivo_mensalidades_empresas"
            id="arquivo_mensalidades_empresas"
            color="#528b46"
            label="Arquivo Mensalidades Empresas"
            variant="outlined"
            size="small"
            disabled
            required
            style={{ width: 300 }}
          />
          <button type="file" className="selectFileButton" onClick={selectFileMensalidadesEmpresas}>
            Escolher Arquivo
          </button>

          <br />
          <input
            type="file"
            name="arquivo_cobranca"
            id="html_cobranca"
            accept=".csv"
            onChange={handleFileCobranca}
            style={{ display: 'none' }}
          />

          <FrTextInput
            value={data.arquivo_cobranca || ''}
            onChange={handleChange}
            name="arquivo_cobranca"
            id="arquivo_cobranca"
            color="#528b46"
            label="Arquivo Cobranças"
            variant="outlined"
            size="small"
            disabled
            required
            style={{ width: 300 }}
          />
          <button type="file" className="selectFileButton" onClick={selectFileCobranca}>
            Escolher Arquivo
          </button>


          <br />
          <input
            type="file"
            name="arquivo_caixa"
            id="html_caixa"
            accept=".csv"
            onChange={handleFileCaixa}
            style={{ display: 'none' }}
          />

          <FrTextInput
            value={data.arquivo_caixa || ''}
            onChange={handleChange}
            name="arquivo_caixa"
            id="arquivo_caixa"
            color="#528b46"
            label="Arquivo Caixa"
            variant="outlined"
            size="small"
            disabled
            required
            style={{ width: 300 }}
          />
          <button type="file" className="selectFileButton" onClick={selectFileCaixa}>
            Escolher Arquivo
          </button>


          <br />
          <input
            type="file"
            name="arquivo_lancamentos"
            id="html_lancamentos"
            accept=".csv"
            onChange={handleFileLancamentos}
            style={{ display: 'none' }}
          />

          <FrTextInput
            value={data.arquivo_lancamentos || ''}
            onChange={handleChange}
            name="arquivo_lancamentos"
            id="arquivo_lancamentos"
            color="#528b46"
            label="Arquivo Lançamentos"
            variant="outlined"
            size="small"
            disabled
            required
            style={{ width: 300 }}
          />
          <button type="file" className="selectFileButton" onClick={selectFileLancamentos}>
            Escolher Arquivo
          </button>

          <br />
          <input
            type="file"
            name="arquivo_renovacoes"
            id="html_renovacoes"
            accept=".csv"
            onChange={handleFileRenovacoes}
            style={{ display: 'none' }}
          />


          <FrTextInput
            value={data.arquivo_renovacoes || ''}
            onChange={handleChange}
            name="arquivo_renovacoes"
            id="arquivo_renovacoes"
            color="#528b46"
            label="Arquivo Renovações"
            variant="outlined"
            size="small"
            disabled
            required
            style={{ width: 300 }}
          />
          <button type="file" className="selectFileButton" onClick={selectFileRenovacoes}>
            Escolher Arquivo
          </button>

          <br />
          <input
            type="file"
            name="arquivo_hist_empresas"
            id="html_hist_empresas"
            accept=".csv"
            onChange={handleFileHistEmpresas}
            style={{ display: 'none' }}
          />


          <FrTextInput
            value={data.arquivo_hist_empresas || ''}
            onChange={handleChange}
            name="arquivo_hist_empresas"
            id="arquivo_hist_empresas"
            color="#528b46"
            label="Arquivo Histórico Empresas"
            variant="outlined"
            size="small"
            disabled
            required
            style={{ width: 300 }}
          />
          <button type="file" className="selectFileButton" onClick={selectFileHistEmpresas}>
            Escolher Arquivo
          </button>
          <br/>
          <input
            type="file"
            name="arquivo_nota_servico"
            id="html_nota_servico"
            accept=".csv"
            onChange={handleFileNotaServico}
            style={{ display: 'none' }}
          />

          <FrTextInput
            value={data.arquivo_nota_servico || ''}
            onChange={handleChange}
            name="arquivo_nota_servico"
            id="arquivo_nota_servico"
            color="#528b46"
            label="Arquivo Tipo Serviço Nota"
            variant="outlined"
            size="small"
            disabled
            required
            style={{ width: 300 }}
          />
          <button type="file" className="selectFileButton" onClick={selectFileNotaServico}>
            Escolher Arquivo
          </button>
          <br/>
          <input
            type="file"
            name="arquivo_nota_fiscal"
            id="html_nota_fiscal"
            accept=".csv"
            onChange={handleFileNotaFiscal}
            style={{ display: 'none' }}
          />

          <FrTextInput
            value={data.arquivo_nota_fiscal || ''}
            onChange={handleChange}
            name="arquivo_nota_fiscal"
            id="arquivo_nota_fiscal"
            color="#528b46"
            label="Arquivo Notas Fiscais"
            variant="outlined"
            size="small"
            disabled
            required
            style={{ width: 300 }}
          />
          <button type="file" className="selectFileButton" onClick={selectFileNotaFiscal}>
            Escolher Arquivo
          </button>


          {texto ?
            <FrLoading text={texto} />
            : <></>}
          <br />
        </form>
        <div className="regButtonsDiv">
          <button onClick={handleSubmit}>Importar</button>
          <button onClick={handleCancel}>Fechar</button>
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Importacao;
